/* eslint-disable unicorn/consistent-function-scoping */
import { AppState, AppThunkDispatch } from '..';
import VimsSFTPUser from '../../services/vims-sftp-users';
import { enqueueSnackbarAction } from '../snackbar/actions';
import { SFTPActionNames } from './types';

export const clearSFTPState = () => async (dispatch: AppThunkDispatch) => dispatch({
  type: SFTPActionNames.SET_DEALER_INFO,
  payload: {
    vimsSftpUserId: '',
    validationRules: [],
    associatedEmailAddresses: [],
  }
});
export const getAllSFTPUsers = () => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
  const {
    login: { client, envVariables },
  } = getState();
  const sftpUsers = new VimsSFTPUser(client, envVariables.vimsSFTPUsers);
  try {
    const results = await sftpUsers.getDealer('')
    dispatch({
      payload: results.data.vimsSftpUsers.map((user: any) => user.vimsSftpUserId),
      type: SFTPActionNames.SET_ALL_DEALERS
    });
    return results.data.vimsSftpUsers.map((user: any) => user.vimsSftpUserId);
  }
  catch (error) {
    dispatch(enqueueSnackbarAction({
      message: `Failed to Load Dealer Codes`,
      options: { variant: 'error' },
    }));
    return [];
  }
}

export const getSFTPUser = (dealerCode: string) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
  const {
    login: { client, envVariables },
  } = getState();
  const sftpUsers = new VimsSFTPUser(client, envVariables.vimsSFTPUsers);
  try {
    const results = await sftpUsers.getDealer(dealerCode)
    if (results.status === 200)
      return dispatch({
        type: SFTPActionNames.SET_DEALER_INFO,
        payload: results.data.vimsSftpUsers[0]
      })
    return await clearSFTPState();
  }
  catch (error) {
    dispatch(enqueueSnackbarAction({
      message: error.message,
      options: { variant: 'error' },
    }));
    return dispatch(clearSFTPState());
  }
};

export const createSFTPUser = (input: any) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
  const {
    login: { client, envVariables },
  } = getState();
  const sftpUsers = new VimsSFTPUser(client, envVariables.vimsSFTPUsers);
  try {
    const response = await sftpUsers.createSFTPUser(input);
    const data = response?.data?.vimsSftpUsers[0];
    if (data.code === 201) {
      dispatch(enqueueSnackbarAction({
        message: "New SFTP User created successfully, Please find the username details",
        options: { variant: 'success' },
      }));
      return data;
    }
    dispatch(enqueueSnackbarAction({
      message: data.description,
      options: { variant: 'error' },
    }));
    return null;
  }
  catch (error: any) {
    dispatch(enqueueSnackbarAction({
      message: error?.response?.data?.vimsSftpUsers[0]?.description || error.message,
      options: { variant: 'error' },
    }));
    return null;
  }
};


export const patchDealer = (dealerCode: string, payload: any) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
  const {
    login: { client, envVariables },
  } = getState();
  const sftpUsers = new VimsSFTPUser(client, envVariables.vimsSFTPUsers);
  try {
    await sftpUsers.patchSFTPUser(dealerCode, payload);
    dispatch(enqueueSnackbarAction({ message: "Saved", options: { variant: 'success' } }));
  }
  catch (error) {
    dispatch(enqueueSnackbarAction({ message: error.message, options: { variant: 'error' } }));
  }
  finally {
    await dispatch(getSFTPUser(dealerCode));
  }
}